import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCommunityFeed } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListMessages } from "@/helpers/permissions";
import { canCreateMessage } from "@/modules/community-feed/permissions";

import { AdminCreatePostPage } from "./pages/admin-create-post/AdminCreatePostPage";
import { CommunityFeedPage } from "./pages/community-feed/CommunityFeedPage";
import { MessageDetailPage } from "./pages/message-detail/MessageDetailPage";
import { PollDetailsPage } from "./pages/poll-details/PollDetailsPage";
import { communityFeedRoutes } from "./routes";

export const communityFeedRoute = [
  {
    path: communityFeedRoutes.list,
    element: (
      <RequireAuth permission={canAccessCommunityFeed}>
        <CommunityFeedPage />
      </RequireAuth>
    ),
  },
  {
    path: communityFeedRoutes.postDetails,
    element: (
      <RequireAuth permission={canListMessages}>
        <MessageDetailPage />
      </RequireAuth>
    ),
  },
  {
    path: communityFeedRoutes.pollDetails,
    element: (
      <RequireAuth permission={canListMessages}>
        <PollDetailsPage />
      </RequireAuth>
    ),
  },
  {
    path: communityFeedRoutes.adminCreatePost,
    element: (
      <RequireAuth permission={canCreateMessage}>
        <AdminCreatePostPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
